import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Flexbox from '../components/misc/Flexbox'; 
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class Articlelist extends Component {
	constructor(props) {
		super(props);
		this.state = {
			animateClass : 'fadeOut'
		}	
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.setState({ animateClass : 'fadeIn' });
		}
	}
	render(){
		const {left,right,name,slug='',start,end,showDate,showText,type,time,clock,video=""} = this.props;
		const { image,title,alt,image_tiny } = this.props.image;
		let divStyle = {
				backgroundImage: 'url(' + image + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}
		let articleText,articleDate,link;
		if(type==='ausstellungen')
			link = "root.programm.ausstellungendetails";
		else
			link = "root.programm.kalenderdetails";
		if(showText==='1')
			articleText = <h1 className="h2" dangerouslySetInnerHTML={createMarkup(name)}></h1>
		if(showDate==='1')
			articleDate = <div className="times">
						<span className="event-start">{start}</span>
                        {(end)? <span className="event-end"> - {end}</span> : null}
						{(time)? <span className="event-end"> - {time} {clock}</span> : null}
					</div>
		return(
			<VisibilitySensor partialVisibility={true} offset={{top:500}} onChange={this.onChange} >
				<section className={`article-list ${this.state.animateClass}`}>
					<Flexbox left={left} right={right} />
					<article className="article-item">
						<UISref to={link} params={{item:slug}}>
							<a> 
								<div className="fixed-ht-img ratio-exhibition" >
                                    <div title={title} className="img-wrapper" style={divStyle} >
									{
										(video!=="")?
											<div>
											{
												(video.type==='html5')?
													<video autoPlay loop muted style={{width:'100%',height:'100%',objectFit:'cover'}}>
														<source src={video.url} type="video/mp4"/>
													</video>
												:
													<iframe width="100%" height="100%" src={video.url+"?autoplay=1&controls=0&loop=1&playsinline=1&showinfo=0&mute=1"}></iframe>
											}		
											</div>
										:	
											null
									}		
                                    </div>
								</div>
								{articleText}
								{articleDate}
							</a>	
						</UISref>
					</article>
				</section> 
			</VisibilitySensor>
		)
	}
}
export default Articlelist;




// WEBPACK FOOTER //
// ./src/components/Articlelist.js